import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './AdminSidebar.css';
import AdminSuiteLogo from "../../../assets/amwAdminSuite.png";
import { signOut } from 'firebase/auth';
import { auth } from '../../../services/firebase';
import { FaBars, FaTimes } from 'react-icons/fa'; // Import FaTimes
import AdminProfileAvatar from "../../../assets/adminprofilepic.png";

const AdminSidebar = () => {
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // New state for full-screen menu
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', path: '/admin/dashboard' },
    { id: 'products', label: 'Products', path: '/admin/products' },
    { id: 'orders', label: 'Orders', path: '/admin/orders' },
    { id: 'customers', label: 'Customers', path: '/admin/customers' },
    { id: 'analytics', label: 'Analytics', path: '/admin/analytics' },
    { id: 'settings', label: 'Settings', path: '/admin/settings' },
  ];

  const handleLogout = async () => {
    try {
      await signOut(auth);
      console.log("User signed out");
      window.location.href = '/login';
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  const renderMenuItems = (items, isMobileMenu = false) => (
    <ul className={isMobileMenu ? "mobile-menu-list" : "menu-list"}>
      {items.map(item => (
        <li
          key={item.id}
          className={`menu-item ${location.pathname === item.path ? 'active' : ''}`}
          onClick={() => {
            if (isMobileMenu) setIsMenuOpen(false); // Close menu on item click
          }}
        >
          <Link to={item.path}>{item.label}</Link>
        </li>
      ))}
    </ul>
  );

  return (
    <>
      {isMobile ? (
        <>
          {/* Mobile Header (the small top bar) */}
          <nav className="admin-sidebar-mobile-header">
            {/* Menu Icon */}
            <FaBars className="mobile-menu-icon" onClick={() => setIsMenuOpen(true)} />

            {/* Logo */}
            <Link to="/admin/dashboard" className="admin-logo">
              <img className="adminNavbarBrand" src={AdminSuiteLogo} alt="Alex Menswear Admin Suite" />
            </Link>

            {/* Profile Dropdown */}
            <div className="admin-avatar-container">
              <img
                className="admin-avatar"
                src={AdminProfileAvatar}
                alt="Admin Avatar"
                onClick={() => setIsProfileDropdownOpen(!isProfileDropdownOpen)}
              />
              {isProfileDropdownOpen && (
                <div className="avatar-dropdown">
                  {/* Logo */}
                  <div className='avatar-header'> <FaTimes className="mobile-close-icon" onClick={() => setIsProfileDropdownOpen(false)} />
                    <Link to="/admin/dashboard" className="admin-logo">
                      <img className="adminNavbarBrand" src={AdminSuiteLogo} alt="Alex Menswear Admin Suite" />
                    </Link>
                  </div>
                  <button onClick={handleLogout}>Logout</button>
                  <Link to="/admin/settings">Settings</Link>
                </div>
              )}
            </div>
          </nav>
          
          {/* Full-Screen Mobile Menu (hidden by default) */}
          <div className={`mobile-full-screen-menu ${isMenuOpen ? 'open' : ''}`}>
            <div className="mobile-menu-header">
            <FaTimes className="mobile-close-icon" onClick={() => setIsMenuOpen(false)} />
              <Link to="/admin/dashboard" className="admin-logo">
                <img className="adminNavbarBrand" src={AdminSuiteLogo} alt="Alex Menswear Admin Suite" />
              </Link>
            </div>
            {renderMenuItems(menuItems, true)}
          </div>
        </>
      ) : (
        /* --- Desktop Sidebar --- */
        <nav className="admin-sidebar">
          <Link to="/admin/dashboard" className="admin-logo">
            <img className="adminNavbarBrand" src={AdminSuiteLogo} alt="Alex Menswear Admin Suite" />
          </Link>
          {renderMenuItems(menuItems)}
          <div className="sidebar-footer">
            <div className="admin-avatar-container">
              <img
                className="admin-avatar"
                src={AdminProfileAvatar}
                alt="Admin Avatar"
                onClick={() => setIsProfileDropdownOpen(!isProfileDropdownOpen)}
              />
              <p>Admin User</p>
              {isProfileDropdownOpen && (
                <div className="avatar-dropdown">
                  <button onClick={handleLogout}>Logout</button>
                  <Link to="/admin/settings">Settings</Link>
                </div>
              )}
            </div>
          </div>
        </nav>
      )}
    </>
  );
};

export default AdminSidebar;